import React, { useEffect, useState } from 'react'
import i18n from '~/components/i18n'
import TableComponent from '~/components/TableComponent'
import { ManagerQuery } from '~/QueryHooks/ManagerQuery'

const getTableColumns = () => [
  {
    name: i18n.t('EVS Nr.'),
    key: 'evsNumber'
  },
  {
    name: i18n.t('AGIS ID Farm'),
    key: 'agisId'
  },
  {
    name: i18n.t('Company name'),
    key: 'companyName'
  },
  {
    name: i18n.t('Street & house number'),
    key: 'streetName',
    type: 'street'
  },
  {
    name: i18n.t('Postal code'),
    key: 'zip'
  },
  {
    name: i18n.t('City'),
    key: 'city'
  },
  {
    name: i18n.t('Canton'),
    key: 'cantonName'
  },
  {
    name: i18n.t('Country'),
    key: 'countryLabel'
  }
]

const FarmersTab: React.FC = () => {
  const [dataFiltered, setDataFiltered] = useState({
    page: 0,
    rows: 20
  })

  const {
    data: farmersData,
    isFetching: isFetchingFarmers,
    refetch: fetchFarmers
  } = ManagerQuery.getFarmersIndex({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  })

  useEffect(() => {
    fetchFarmers()
  }, [dataFiltered])

  const { filtered, rows } = farmersData ? farmersData : { filtered: 0, rows: [] }

  return (
    <TableComponent
      tableColumnHeaders={getTableColumns()}
      rows={rows}
      total={filtered}
      isFetchingData={isFetchingFarmers}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      animated
    />
  )
}

export default FarmersTab
